import { Component, computed, inject } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';
import { BtOrderAccessoryItemComponent } from '../order-accessory-item/order-accessory-item.component';

@Component({
  selector: 'btlib-order-accessories',
  standalone: true,
  imports: [LibModulesWolcModule, BtOrderAccessoryItemComponent],
  templateUrl: './order-accessories.component.html',
  styleUrl: './order-accessories.component.scss'
})
export class BtOrderAccessoriesComponent {
  state = inject(CartItemStateService);
  mandatory = this.state.mandatoryAccessories;
  // Hide optional accessories that are not available (no price for the period),
  // mirroring legacy behavior. Mandatory accessories are always shown.
  optional = computed(() =>
    this.state.optionalAccessories().filter(a => a.available)
  );
}
